import { Company } from 'module/api/company/types';
import { Avatar } from 'module/ui/components/atoms/avatar';
import { Breadcrumb } from 'module/ui/components/atoms/breadcrumb';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Page } from 'module/ui/components/molecules/page';
import { Argon, ArgonProps } from 'module/ui/components/templates/argon';
import { faBuildings } from '@fortawesome/pro-solid-svg-icons';
import { Link } from '@rocketlane/rocket-router';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ROUTE_PATHS } from 'routes/route-paths';
import { IconWrapper } from 'components/common/styles';

interface Props extends Omit<
  ArgonProps,
  'title' | 'breadcrumbs' | 'documentTitle'
> {
  company: Company;
}

export const AccountLayout: FC<Props> = ({ company, ...rest }) => {
  return (
    <Argon
      documentTitle={company.companyName}
      breadcrumbs={
        <>
          <Breadcrumb.Item>
            <Link to={`/${ROUTE_PATHS.ACCOUNTS}`}>
              <FormattedMessage id="accounts.page.title" />
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>&nbsp;</Breadcrumb.Item>
        </>
      }
      title={
        <IconWrapper>
          {company.companyLogoUrl == null ? (
            <FontAwesomeIcon icon={faBuildings} size={16} />
          ) : (
            <Avatar
              shape="square"
              size={16}
              name={company.companyName}
              src={company.companyLogoUrl}
            />
          )}
          <Page.Header.Title>{company.companyName}</Page.Header.Title>
        </IconWrapper>
      }
      {...rest}
    />
  );
};
